import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
interface NetworkImageProps {
  lightImage: string | null;
  darkImage: string | null;
  alt: string;
  size: number;
  lightClassName?: string;
  darkClassName?: string;
  singleClassName?: string;
  useImgTag?: boolean;
  showName?: boolean;
  networkName?: string;
  containerClassName?: string;
}

/**
 * Renders a network image with automatic light/dark theme support
 */
function NetworkImage(t0) {
  const $ = _c(41);
  const {
    lightImage,
    darkImage,
    alt,
    size,
    lightClassName: t1,
    darkClassName: t2,
    singleClassName: t3,
    useImgTag: t4,
    showName: t5,
    networkName,
    containerClassName
  } = t0;
  const lightClassName = t1 === undefined ? "" : t1;
  const darkClassName = t2 === undefined ? "" : t2;
  const singleClassName = t3 === undefined ? "" : t3;
  const useImgTag = t4 === undefined ? false : t4;
  const showName = t5 === undefined ? false : t5;
  if (!lightImage && !darkImage) {
    return null;
  }
  let t6;
  if ($[0] !== alt || $[1] !== size || $[2] !== useImgTag) {
    t6 = (src, className) => useImgTag ? <img src={src} alt={alt} fetchPriority="high" className={className} /> : <Image src={src} alt={alt} width={size} height={size} priority={true} unoptimized={true} fetchPriority="high" className={className} />;
    $[0] = alt;
    $[1] = size;
    $[2] = useImgTag;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const renderImage = t6;
  let t7;
  if ($[4] !== containerClassName || $[5] !== networkName || $[6] !== showName) {
    t7 = element => {
      if (showName && networkName) {
        return <div className={containerClassName}>{element}<span className="font-bold">{networkName}</span></div>;
      }
      return element;
    };
    $[4] = containerClassName;
    $[5] = networkName;
    $[6] = showName;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const wrapWithContainer = t7;
  if (lightImage && !darkImage) {
    const t8 = singleClassName || lightClassName;
    let t9;
    if ($[8] !== lightImage || $[9] !== renderImage || $[10] !== t8 || $[11] !== wrapWithContainer) {
      t9 = wrapWithContainer(renderImage(lightImage, t8));
      $[8] = lightImage;
      $[9] = renderImage;
      $[10] = t8;
      $[11] = wrapWithContainer;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    return t9;
  }
  if (!lightImage && darkImage) {
    const t8 = singleClassName || darkClassName;
    let t9;
    if ($[13] !== darkImage || $[14] !== renderImage || $[15] !== t8 || $[16] !== wrapWithContainer) {
      t9 = wrapWithContainer(renderImage(darkImage, t8));
      $[13] = darkImage;
      $[14] = renderImage;
      $[15] = t8;
      $[16] = wrapWithContainer;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    return t9;
  }
  if (lightImage && darkImage) {
    if (lightImage === darkImage) {
      const t8 = singleClassName || lightClassName;
      let t9;
      if ($[18] !== lightImage || $[19] !== renderImage || $[20] !== t8 || $[21] !== wrapWithContainer) {
        t9 = wrapWithContainer(renderImage(lightImage, t8));
        $[18] = lightImage;
        $[19] = renderImage;
        $[20] = t8;
        $[21] = wrapWithContainer;
        $[22] = t9;
      } else {
        t9 = $[22];
      }
      return t9;
    }
    let t8;
    if ($[23] !== lightClassName || $[24] !== lightImage || $[25] !== renderImage) {
      t8 = renderImage(lightImage, lightClassName);
      $[23] = lightClassName;
      $[24] = lightImage;
      $[25] = renderImage;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    const lightElement = t8;
    let t9;
    if ($[27] !== darkClassName || $[28] !== darkImage || $[29] !== renderImage) {
      t9 = renderImage(darkImage, darkClassName);
      $[27] = darkClassName;
      $[28] = darkImage;
      $[29] = renderImage;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    const darkElement = t9;
    if (showName && networkName && containerClassName) {
      let t10;
      if ($[31] !== networkName) {
        t10 = <span className="font-bold">{networkName}</span>;
        $[31] = networkName;
        $[32] = t10;
      } else {
        t10 = $[32];
      }
      let t11;
      if ($[33] !== containerClassName || $[34] !== darkElement || $[35] !== lightElement || $[36] !== t10) {
        t11 = <div className={containerClassName}>{lightElement}{darkElement}{t10}</div>;
        $[33] = containerClassName;
        $[34] = darkElement;
        $[35] = lightElement;
        $[36] = t10;
        $[37] = t11;
      } else {
        t11 = $[37];
      }
      return t11;
    }
    let t10;
    if ($[38] !== darkElement || $[39] !== lightElement) {
      t10 = <>{lightElement}{darkElement}</>;
      $[38] = darkElement;
      $[39] = lightElement;
      $[40] = t10;
    } else {
      t10 = $[40];
    }
    return t10;
  }
  return null;
}
export { NetworkImage };